
import { CheckCheck, Copy, BotIcon, UserCircle } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

interface ChatMessageProps {
  message: {
    id: string;
    role: "user" | "assistant" | "system";
    content: string;
    timestamp: string;
  };
}

const ChatMessage = ({ message }: ChatMessageProps) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(message.content);
    setIsCopied(true);
    toast.success("Copied to clipboard");
    
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <div
      className={`mb-4 flex ${
        message.role === "user" ? "justify-end" : "justify-start"
      }`}
    >
      <div
        className={`${
          message.role === "user"
            ? "bg-primary text-primary-foreground"
            : "bg-muted"
        } rounded-lg px-4 py-2 max-w-[80%] group relative`}
      >
        <div className="flex items-center gap-2 mb-1">
          {message.role === "user" ? (
            <UserCircle className="h-4 w-4" />
          ) : (
            <BotIcon className="h-4 w-4" />
          )}
          <span className="text-xs">
            {message.role === "user" ? "You" : "AI Assistant"}
          </span>
          
          {message.role === "assistant" && (
            <button
              onClick={copyToClipboard}
              className="opacity-0 group-hover:opacity-100 transition-opacity absolute top-2 right-2 p-1 rounded-md hover:bg-muted-foreground/10"
            >
              {isCopied ? (
                <CheckCheck className="h-3.5 w-3.5" />
              ) : (
                <Copy className="h-3.5 w-3.5" />
              )}
            </button>
          )}
        </div>
        <p className="whitespace-pre-wrap">{message.content}</p>
        <div className="text-xs opacity-70 text-right mt-1">
          {new Date(message.timestamp).toLocaleTimeString()}
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;
